import React from 'react';
import '../App.css';
import './HeroSection.css';


function HeroSection() {

  return (

    <div class="man-o">
      <div className='HersoSection'>
        <div class="typing-demo mb-3">
          Hi, my name is
        </div>
        <div class="Name pb-3">
          <span>T</span>
          <span>u</span>
          <span>s</span>
          <span>h</span>
          <span>a</span>
          <span>r</span>
          <span> </span>
          <span>K</span>
          <span>a</span>
          <span>r</span>
          <span>a</span>
          <span>n</span>
        </div>
        <div class="Text-intro">I build things for the web.</div>

        <h1 class="abc">
          <span>I’m</span>
          <span>currently</span>
          <span>looking</span>
          <span>for</span>
          <span>co-op</span>
          <span>opportunities.</span>
          <span>As</span>
          <span>a</span>
          <span>software</span>
          <span>engineer</span>
          <span>specializing</span>
          <span>in</span>
          <span>creating</span>
          <span>exceptional</span>
          <span>user</span>
          <span>experiences,</span>
          <span>I</span>
          <span>am</span>
          <span>studying</span>
          <span>at</span>
          <span>the</span>
          <span>University</span>
          <span>of</span>
          <span>Windsor.</span>
          <span>My</span>
          <span>passion</span>
          <span>lies</span>
          <span>in</span>
          <span>developing</span>
          <span>innovative</span>
          <span>and</span>
          <span>accessible</span>
          <span>technology</span>
          <span>solutions.</span>
        </h1>


        {/* <a class="button-rotating" href="#contact-data">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          Contact Me
        </a> */}
      </div>
    </div>

  );
}

export default HeroSection;